import Image from 'next/image';
import Link from 'next/link';

import { getStoryblokImageUrl } from '@/lib/utils';

import Heading from '../Heading';
import PreHeading from '../PreHeading';

export default function Spotlight({
  name,
  position,
  hero_feature_image,
  preview,
  // _editable,
}) {
  return (
    <Link href={`/staff#${name}`} className="grid self-stretch" legacyBehavior>
      <div className="relative bg-theme-lightgrey" id={name}>
        <div className="relative aspect-[5/3] overflow-hidden">
          <Image
            alt={hero_feature_image?.alt}
            src={getStoryblokImageUrl(hero_feature_image?.filename, 634, 380)}
            width={634}
            height={380}
            className="size-full object-cover"
          />
        </div>
        <div className="relative items-center bg-theme-lightgrey p-6 md:p-8">
          <div className="space-y-6">
            <div className="space-y-2">
              <PreHeading size="sm" element="h3" color="text-theme-darkgrey">
                {position}
              </PreHeading>
              <Heading size="xs" className="mb-4">
                {name}
              </Heading>
            </div>
            <p className="max-w-[42ch] text-lg">{preview}</p>
          </div>
        </div>
      </div>
    </Link>
  );
}
